<div [stickyPopover]="popContent"
     [popoverTitle]="popTitle"
     [autoClose]="false"
     [animation]="false"
     popoverClass="target-list-popover"
     triggers="manual"
     placement="bottom-start"
     style="font-size: 0.75rem">
    <span *ngIf="targetListLinesResolved?.length > 0"
          class="text-primary text-decoration-underline">
    Target list resolved. See details
  </span>
</div>

<ng-template #popTitle>
  Target list
</ng-template>
<ng-template #popContent>
  <ol class="list-group list-group-numbered"
      style="font-size: 0.75rem;max-height: 15rem; overflow-y:auto;">
    <ng-container *ngFor="let line of targetListLinesResolved">
      <ng-container *ngIf="line.text">
        <li class="list-group-item">
          <span class="me-1">{{line.text | truncate: 20: '...'}}</span>
          <i *ngIf="line.isValid" class="fa-light fa-check text-success"></i>
          <i *ngIf="!line.isValid" class="fa-light fa-xmark text-danger"></i>
        </li>
      </ng-container>
    </ng-container>
  </ol>
</ng-template>
